module.exports = __webpack_public_path__ + "static/media/feelingProud.ff50ed3d.png";